<div class="my-request--container">
  <div class="status-tabs">
    <button
      *ngFor="let tab of statusTabs"
      class="status-tab"
      [class.active]="activeStatus === tab.key"
      [class.status-approved]="tab.key === 'approved'"
      [class.status-pending]="tab.key === 'pending'"
      [class.status-rejected]="tab.key === 'rejected'"
      [class.status-withdrawn]="tab.key === 'withdrawn'"
      (click)="filterByStatus(tab.key)"
    >
      <span class="status-tab-label">{{ tab.label }}</span>
    </button>
  </div>

  <div class="requests-table-wrapper">
    <div class="custom-table-container">
      <div *ngIf="loading" class="table-loading">
        <div *ngFor="let i of [1,2,3,4,5]" class="skeleton skeleton-text"></div>
      </div>

      <div *ngIf="!loading && (!requestsData || requestsData.length === 0)" class="table-empty">
        <p [innerHTML]="emptyMessage"></p>
      </div>

      <div *ngIf="!loading && requestsData && requestsData.length > 0" class="custom-table-wrapper">
        <table class="custom-table">
          <thead>
            <tr>
              <th style="width: 3%"></th>
              <th style="width: 20%">Name</th>
              <th style="width: 15%">Type</th>
              <th style="width: 15%">Request Type</th>
              <th style="width: 15%">Request Created At</th>
              <th style="width: 12%">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of displayedRequests">
              <tr class="main-row" [class.dropdown-open]="isDropdownOpen(row)" [attr.data-request-id]="row.id">
                <td>
                  <button
                    type="button"
                    class="row-expand-toggle"
                    [class.expanded]="isRowExpanded(row.id)"
                    (click)="toggleExpansion(row.id)"
                    [attr.aria-expanded]="isRowExpanded(row.id)"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </td>
                <td>{{ row.name }}</td>
                <td>
                  <div class="type-cell">
                    <img
                      *ngIf="getAssetTypeIconSrc(row.type)"
                      [src]="getAssetTypeIconSrc(row.type)"
                      [alt]="formatAssetTypeLabel(row.type)"
                      class="type-icon-img"
                    />
                    <svg
                      *ngIf="!getAssetTypeIconSrc(row.type)"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      [innerHTML]="getAssetTypeIcon(row.type)"
                    ></svg>
                    <span>{{ formatAssetTypeLabel(row.type) }}</span>
                  </div>
                </td>
                <td>{{ row.requestType }}</td>
                <td>
                  <div class="date-cell">
                    <span class="date-part">{{ formatDatePart(row.requestCreatedAt) }}</span>
                    <span class="time-part">{{ formatTimePart(row.requestCreatedAt) }}</span>
                  </div>
                </td>
                <td>
                  <div class="action-cell-wrapper" (click)="$event.stopPropagation()">
                    <button
                      class="action-btn"
                      type="button"
                      appActionDropdownTrigger
                      [class.active]="isDropdownOpen(row)"
                      (click)="toggleActionDropdown($event, row)"
                    >
                      <span>Action</span>
                    </button>

                    <div
                      class="action-dropdown-menu"
                      *ngIf="isDropdownOpen(row)"
                      [attr.data-dropdown-id]="row.id"
                      (click)="$event.stopPropagation()"
                    >
                      <ul class="dropdown-list">
                        <li class="dropdown-item">
                          <button class="dropdown-link" (click)="onActionClick('view', row)">
                            View
                          </button>
                        </li>
                        <li class="dropdown-item" *ngIf="row.status === 'pending'">
                          <button class="dropdown-link dropdown-link--danger" (click)="onActionClick('withdraw', row)">
                            Withdraw
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>

              <tr class="expansion-row" *ngIf="isRowExpanded(row.id)">
                <td colspan="6" class="expansion-cell">
                  <div class="row-expansion">
                    <div class="expansion-section">
                      <span class="expansion-title">Requested as</span>
                      <span class="expansion-value">{{ row.requestAs === 'Organisation' ? (row.organisation || 'N/A') : 'Individual' }}</span>
                    </div>
                    <div class="expansion-section">
                      <span class="expansion-title">Purpose</span>
                      <span class="expansion-value">{{ row.purpose || 'N/A' }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <p-paginator
        *ngIf="shouldShowPagination && !loading"
        [rows]="pagination.pageSize"
        [totalRecords]="pagination.totalItems"
        [first]="(pagination.currentPage - 1) * pagination.pageSize"
        [rowsPerPageOptions]="[]"
        (onPageChange)="onPageChange($event)"
        styleClass="table--paginator"
      ></p-paginator>
    </div>
  </div>
</div>
